import { DEVELOPMENT_PORTS, LOCALHOST_IDENTIFIERS } from "@/constants/recaptcha.constants";

/**
 * Utilitários para detectar o ambiente de execução
 * Implementa Single Responsibility Principle
 */

/**
 * Verifica se a aplicação está sendo executada em localhost
 * @returns true se estiver em localhost, false caso contrário
 */
export const isLocalhost = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  const { hostname, port } = window.location;

  const isLocalHostname = LOCALHOST_IDENTIFIERS.some(
    (identifier) => hostname === identifier || hostname.includes(identifier)
  );

  const isDevelopmentPort = DEVELOPMENT_PORTS.some((developmentPort) => port === developmentPort);

  return isLocalHostname || (isLocalHostname && isDevelopmentPort);
};

/**
 * Verifica se está em ambiente de preview (Lovable ou iframe)
 */
export const isPreviewEnvironment = (): boolean => {
  if (typeof window === "undefined") return false;
  const hostname = window.location.hostname;
  const isInIframe = (() => {
    try { return window.self !== window.top; } catch { return true; }
  })();
  return (
    isInIframe ||
    hostname.includes("id-preview--") ||
    hostname.includes("lovable.app") ||
    hostname.includes("lovableproject.com")
  );
};

/**
 * Verifica se está em ambiente de desenvolvimento
 * @returns true se estiver em desenvolvimento
 */
/**
 * Verifica se o app está rodando como PWA instalada (modo standalone)
 * @returns true se estiver em modo standalone (PWA instalada)
 */
export const isPWAStandalone = (): boolean => {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    (navigator as any).standalone === true
  );
};

export const isDevelopment = (): boolean => {
  return import.meta.env.DEV || isLocalhost();
};

/**
 * Verifica se deve pular a verificação do reCAPTCHA
 * Em preview/iframe, não há necessidade de verificar reCAPTCHA
 * @returns true se deve pular a verificação
 */
export const shouldSkipRecaptchaVerification = (): boolean => {
  return isPreviewEnvironment();
};
